const AX_INSTRUCTIONS_ACTION = {
    NEXT_STEP: 'NEXT_STEP',
    PREV_STEP: 'PREV_STEP',
    FINAL_STEP: 'FINAL_STEP',
    UPDATE_FORM: 'UPDATE_FORM',
    UPDATE_ATTEMPTS: 'UPDATE_ATTEMPTS',
    UPDATE_CURRENT_STEP_STATUS: 'UPDATE_CURRENT_STEP_STATUS',
    UPDATE_OTP: 'UPDATE_OTP',
    UPDATE_ASSESSMENT: 'UPDATE_ASSESSMENT',
    UPDATE_STEPS: 'UPDATE_STEPS',
    UPDATE_ABIDE_HONOUR_CODE: 'UPDATE_ABIDE_HONOUR_CODE',
    UPDATE_CHALLENGE: 'UPDATE_CHALLENGE',
    UPDATE_RETRY_ENABLED: 'UPDATE_RETRY_ENABLED',
    SET_FULL_SCREEN_EXIT_STATE: 'SET_FULL_SCREEN_EXIT_STATE',
}

export default AX_INSTRUCTIONS_ACTION
